export const initialState = {
    downloads: [],
};
